import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoadingTask {

    private IsLoadingSubject: Subject<boolean> = new Subject<boolean>();
    private IsLoadingAndBlockingSubject: Subject<boolean> = new Subject<boolean>();
    LoadingCount = 0;

    constructor() {
    }

    get LoadingEmitter() {
        return this.IsLoadingSubject;
    }

    get LoadingAndBlockingEmitter() {
        return this.IsLoadingAndBlockingSubject;
    }

    get IsLoading() {
        return this.LoadingCount > 0
    }

    activateLoading(withBlocking?: boolean) {
        if (withBlocking && this.LoadingCount === 0) {
            this.IsLoadingAndBlockingSubject.next(true);
        } else if (this.LoadingCount === 0) {
            this.IsLoadingSubject.next(true);
        }
        this.LoadingCount++;
    }

    deactivateLoading() {
        this.LoadingCount--;
        if (this.LoadingCount <= 0) {
            this.IsLoadingAndBlockingSubject.next(false);
            this.IsLoadingSubject.next(false);
        }
    }

    cleanLoading() {
        this.LoadingCount = 0;
        this.IsLoadingAndBlockingSubject.next(false);
        this.IsLoadingSubject.next(false);
    }
}
